import { IAppState } from '../../../types/redux';

export const selectNewbuildingBrokerSelfRequestFormWidgetActive = (state: IAppState): boolean =>
  state.newbuildingBrokerSelfRequestFormWidget.active;
